import { Link, useLocation } from 'react-router-dom';
import {
    SidebarGroup,
    SidebarGroupContent,
    SidebarGroupLabel,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
} from '@/components/ui/sidebar';
import { RenderIf } from '@/components/RenderIf';
import type { SidebarNavGroupProps } from './types';

const SidebarNavGroup = ({ label, items }: SidebarNavGroupProps) => {
    const location = useLocation();

    const isItemActive = (url: string) => location.pathname.startsWith(url);

    return (
        <SidebarGroup>
            <RenderIf isTrue={label.length > 0}>
                <SidebarGroupLabel>{label}</SidebarGroupLabel>
            </RenderIf>
            <SidebarGroupContent>
                <SidebarMenu>
                    {items.map(item => (
                        <SidebarMenuItem key={item.title}>
                            <SidebarMenuButton
                                asChild
                                isActive={isItemActive(item.url)}
                                className="text-md"
                            >
                                <Link to={item.url}>
                                    <item.icon />
                                    <span>{item.title}</span>
                                </Link>
                            </SidebarMenuButton>
                        </SidebarMenuItem>
                    ))}
                </SidebarMenu>
            </SidebarGroupContent>
        </SidebarGroup>
    );
};

export default SidebarNavGroup;
